import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import { Typography } from '@mui/material'

export const CustomBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: 'linear-gradient(90deg, #f7825d 0%, #ce4a23 100%)',
  height: '55px',
  width: '100%',
  '.contain-header-top-limited': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '55px',
    width: '100%',
    maxWidth: '1200px',
    padding: '0px var(--padding-mid)',
    background: 'transparent',
    boxShadow: 'none',
  },
  '.contain-header-img-title': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'auto',
    height: '55px',
    padding: '0px',
    cursor: 'pointer',
  },
  '.contain-header-img-title > img': {
    width: 'auto',
    height: '40px',
    marginRight: '10px',
    marginBottom: '5px',
  },
  '.title-aplication': {
    fontFamily: 'rez-regular',
  },
  'contain-header-children': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'auto',
    width: 'auto',
  },
}))

export const AuthBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  height: '55px',
  width: 'auto',
  padding: '0px',
  marginRight: '10px',
  backgroundColor: 'transparent',
}))

export const TitleName = styled(Typography)(() => ({
  fontFamily: 'jost-light',
  color: 'white',
  fontSize: '1rem',
  fontWeight: 'bold',
  textAlign: 'center',
  marginRight: '10px',
}))
